import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle'

export const signingColumns = [
  {
    title: '服务签约号',
    key: 'signId',
    width: 190
  },
  {
    title: '学生姓名',
    key: 'studentName',
    width: 120
  },
  {
    title: '年级班级',
    key: 'gradeClassName',
    width: 120
  },
  {
    title: '学校',
    slot: 'schoolName',
    minWidth: tableColumnsWidth.type6
  },
  {
    title: '学期',
    key: 'yearTermName',
    width: tableColumnsWidth.type4
  },
  {
    title: '机构提供方',
    slot: 'orgName',
    minWidth: tableColumnsWidth.type6
  },
  {
    title: '是否已签约',
    slot: 'signSts',
    width: 120,
    align: 'center'
  },
  {
    title: '签约完成时间',
    key: 'signTime',
    width: 190
  },
  {
    title: '签约家长手机号码',
    key: 'signPhoneNo',
    width: 150,
    align: 'center'
  },
  {
    title: '与孩子关系',
    key: 'relationName',
    width: 120,
    align: 'center'
  },
  {
    title: '学期已选课程',
    slot: 'classroomNames',
    minWidth: tableColumnsWidth.type6
  },
  {
    title: '操作',
    slot: 'action',
    width: 150,
    align: 'center',
    fixed: 'right'
  }
]
